module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "bb8-block"
  }, [_h('div', {
    staticClass: "bb8-block-text",
    attrs: {
      "required": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    },
    on: {
      "blur": function($event) {
        _vm.updateText($event)
      },
      "keydown": function($event) {
        if (_vm._k($event.keyCode, "delete", [8, 46])) { return; }
        _vm.removeBlock($event)
      }
    }
  }), " ", _vm._t("default")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1fabcb8e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/TextBlock.vue
// module id = 40
// module chunks = 0